import { useProductFeatures } from 'bundles/custom-labels/features';
import { IdTypes } from 'bundles/product-features';

/**
 * Lightweight hook that only fetches product features for custom labels (enableCustomLabels).
 * Use this for prefetching in data providers so only the ProductFeatures query runs;
 * useCustomLabelsByCourseBranch uses this same hook and then runs CustomLabelsV2 and
 * WeekToModuleStatus when enableCustomLabels is true.
 */
const useCustomLabelsFromProductFeatures = (courseBranchId: string | undefined) => {
  const { features, loading } = useProductFeatures({
    idType: IdTypes.Course,
    id: courseBranchId || '',
    skip: !courseBranchId,
    ssr: true,
  });
  const enableCustomLabels = features.get('globalCourseFeatures', 'enableCustomLabels');

  return {
    features,
    loading,
    enableCustomLabels,
  };
};

export default useCustomLabelsFromProductFeatures;
